var chunkMapping = {
	"105": [
		66105
	],
	"120": [
		77349
	],
	"168": [
		60229
	],
	"186": [
		52869
	],
	"194": [
		50565
	],
	"268": [
		96268
	],
	"324": [
		71324
	],
	"352": [
		98352
	],
	"367": [
		23067
	],
	"464": [
		32464
	],
	"484": [
		64421
	],
	"507": [
		44507
	],
	"620": [
		27620
	],
	"694": [
		95433
	],
	"711": [
		24027
	],
	"742": [
		31818
	],
	"812": [
		6812
	],
	"825": [
		55825
	],
	"827": [
		53525
	],
	"901": [
		87567
	]
};
var idToExternalAndNameMapping = {
	"6812": [
		"default",
		"./WidgetCustomerService",
		37289
	],
	"23067": [
		"default",
		"./SellerIntegratorApp",
		84166
	],
	"24027": [
		"default",
		"./CouponApp",
		87661
	],
	"27620": [
		"default",
		"./WidgetLogistics",
		66937
	],
	"31818": [
		"default",
		"./ProductApp",
		29713
	],
	"32464": [
		"default",
		"./WidgetFinancial",
		41545
	],
	"44507": [
		"default",
		"./ProductWidgetSku",
		29713
	],
	"50565": [
		"default",
		"./SupportApp",
		37289
	],
	"52869": [
		"default",
		"./LogisticsApp",
		66937
	],
	"53525": [
		"default",
		"./OrderApp",
		8463
	],
	"55825": [
		"default",
		"./WidgetSalesOverview",
		8463
	],
	"60229": [
		"default",
		"./ReputationApp",
		51097
	],
	"64421": [
		"default",
		"./BrandApp",
		79045
	],
	"66105": [
		"default",
		"./WidgetHelpCenter",
		37289
	],
	"71324": [
		"default",
		"./SellerSupportWidgetNeedsAttention",
		37289
	],
	"77349": [
		"default",
		"./PriceApp",
		71849
	],
	"87567": [
		"default",
		"./SellerManagementApp",
		88640
	],
	"95433": [
		"default",
		"./FinancialApp",
		41545
	],
	"96268": [
		"default",
		"./WidgetReputation",
		51097
	],
	"98352": [
		"default",
		"./BigWidgetLogistics",
		66937
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}